var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoProductandintegration24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.001,
    height: 18,
    viewBox: "0 0 15.001 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_productandintegration24x24",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "internet",
    transform: "translate(-38.666 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25064",
    "data-name": "Group 25064",
    transform: "translate(42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25063",
    "data-name": "Group 25063",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46108",
    "data-name": "Path 46108",
    d: "M77.125,314.958h-5.25v-.375a.375.375,0,0,0-.375-.375h-.375v-.844c.746-.342,1.451-1.665,1.865-3.576a.374.374,0,0,0-.366-.454H68.876a.374.374,0,0,0-.366.454c.414,1.911,1.12,3.235,1.865,3.576v.844H70a.375.375,0,0,0-.375.375v.375h-5.25a.375.375,0,0,0,0,.75h5.25v.375a.375.375,0,0,0,.375.375h1.5a.375.375,0,0,0,.375-.375v-.375h5.25a.375.375,0,0,0,0-.75Z",
    transform: "translate(-63.25 -298.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46109",
    "data-name": "Path 46109",
    d: "M315.136,312.889a.376.376,0,0,0,.281.127.366.366,0,0,0,.129-.023,7.534,7.534,0,0,0,3.789-3.087.375.375,0,0,0-.319-.573H316.37a.375.375,0,0,0-.368.3,10.721,10.721,0,0,1-.917,2.833.375.375,0,0,0,.051.423Z",
    transform: "translate(-305.467 -298.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46110",
    "data-name": "Path 46110",
    d: "M192.107,3.985a.376.376,0,0,0,.292.14h3.749a.374.374,0,0,0,.366-.454C196.031,1.441,195.151,0,194.274,0s-1.757,1.441-2.24,3.671a.375.375,0,0,0,.073.314Z",
    transform: "translate(-186.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46111",
    "data-name": "Path 46111",
    d: "M186.081,143.916a.376.376,0,0,0,.373-.331,20.468,20.468,0,0,0,0-4.587.376.376,0,0,0-.373-.331h-4.247a.376.376,0,0,0-.373.331,20.468,20.468,0,0,0,0,4.587.376.376,0,0,0,.373.331Z",
    transform: "translate(-176.458 -133.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46112",
    "data-name": "Path 46112",
    d: "M46.817,143.791a.374.374,0,0,0,.094-.291,20.383,20.383,0,0,1,0-4.419.375.375,0,0,0-.373-.415H43.409a.376.376,0,0,0-.356.256,7.434,7.434,0,0,0,0,4.737.376.376,0,0,0,.356.256h3.129a.376.376,0,0,0,.279-.124Z",
    transform: "translate(-42.666 -133.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46113",
    "data-name": "Path 46113",
    d: "M73.624,16.253h2.647a.375.375,0,0,0,.368-.3,10.719,10.719,0,0,1,.917-2.833.375.375,0,0,0-.462-.524A7.534,7.534,0,0,0,73.3,15.683a.375.375,0,0,0,.319.573Z",
    transform: "translate(-72.174 -12.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46114",
    "data-name": "Path 46114",
    d: "M352.379,138.922a.376.376,0,0,0-.356-.256h-3.129a.375.375,0,0,0-.373.415,20.385,20.385,0,0,1,0,4.419.375.375,0,0,0,.373.415h3.129a.376.376,0,0,0,.356-.256,7.435,7.435,0,0,0,0-4.737Z",
    transform: "translate(-337.766 -133.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46115",
    "data-name": "Path 46115",
    d: "M76.271,309.333H73.624a.375.375,0,0,0-.319.573,7.534,7.534,0,0,0,3.789,3.087.366.366,0,0,0,.129.023.375.375,0,0,0,.333-.547,10.718,10.718,0,0,1-.917-2.833A.375.375,0,0,0,76.271,309.333Z",
    transform: "translate(-72.174 -298.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46116",
    "data-name": "Path 46116",
    d: "M316,15.948a.375.375,0,0,0,.368.3h2.647a.375.375,0,0,0,.319-.573,7.535,7.535,0,0,0-3.789-3.087.375.375,0,0,0-.462.524A10.721,10.721,0,0,1,316,15.948Z",
    transform: "translate(-305.468 -12.127)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoProductandintegration24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_productandintegration24x24.f312bd3071cef058652b7d7291370ff8.svg";